<router-outlet></router-outlet>

<app-landing (closeLanding)="showLanding.setIsLandingShowed(false)" *ngIf="showLanding.isLandingShowed()"></app-landing>
